export default __webpack_public_path__ + "static/media/deactivator.14ef206c.png";